import ROUTES from "../../application/utils/Routes";
import { getItemFromStorage, removeItemFromStorage, storeKeys } from "../../application/utils/Storage";

// export const BASEURL = "http://localhost:3000";
export const BASEURL = "https://ufarmx-new-mobile-be.onrender.com";
export const setConfig = () => {
    const authToken = getItemFromStorage(storeKeys.userdata)?.accessToken;

    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
            ContentType: "application/x-www-form-urlencoded",
        },
    };

    return config;
};

export const requestWrapper = async (request) => {
    try {
        const res = await request;

        return res.data;
    }

    catch (err) {

        if(err.response?.status == 401){
            removeItemFromStorage(storeKeys.userdata);
            window.location.href = ROUTES.LOGIN;
        }

        if (err?.response?.data?.message) throw err?.response?.data?.message;

        if(err?.response?.data) throw err?.response?.data;

        if(err.message) throw err.message;

        throw err;
    }
}